/**
 * Envia dados para o MailingBoss via API (member.mailingboss.com) através do proxy Next.js
 * (/api/mailingboss/subscribe), evitando CORS. Fire-and-forget: não bloqueia e ignora erros.
 *
 * Candidatos: FNAME, EMAIL, PHONE, CPF. Empresas: NOMEEMPRESA, FNAME, EMAIL, WHATSAPP, CNPJ.
 * UTMs (utm_source, utm_medium, utm_campaign, ...) são repassadas como tags UTM_* quando presentes.
 */
type UTMFields = {
	[key: `utm_${string}`]: string | undefined;
};

export type MailingBossCandidatePayload = UTMFields & {
	fullname?: string;
	email?: string;
	phone?: string[];
	cpf?: string;
};

export type MailingBossCompanyPayload = UTMFields & {
	fullname?: string;
	contactname?: string;
	email?: string;
	whatsapp?: string;
	cnpj?: string;
};

export function subscribeToMailingBoss(
	type: 'candidate',
	payload: MailingBossCandidatePayload
): void;
export function subscribeToMailingBoss(
	type: 'company',
	payload: MailingBossCompanyPayload
): void;
export function subscribeToMailingBoss(
	type: 'candidate' | 'company',
	payload: MailingBossCandidatePayload | MailingBossCompanyPayload
): void {
	fetch('/api/mailingboss/subscribe', {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify({ type, payload }),
		credentials: 'same-origin',
	}).catch(() => {
		// fire-and-forget: não impacta UX
	});
}
